import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { UnitLabel } from "./UnitLabel";
import { unitOf } from "./pricingUnits";

// صف شريحة تسعير الاشتراك — يدعم وضع للاطلاع فقط (readonly) بنفس التصميم Neu.
export const TierRow = ({ tier, index, onChange, onRemove, currency = "USD", readonly = false }) => {
  const { t } = useTranslation();
  const cells = [
    ["min_employees", "platformExtra.tierFrom", `tier-min-${index}`, tier.min_employees, undefined, "platformExtra.unitEmployee"],
    ["max_employees", "platformExtra.tierTo", `tier-max-${index}`, tier.max_employees ?? "", t("platformExtra.unlimited"), "platformExtra.unitEmployee"],
    ["price_per_employee", "platformExtra.pricePerEmployee", `tier-price-${index}`, tier.price_per_employee, undefined, "per_employee"],
  ];

  return (
    <li className={`grid gap-2 ${readonly ? "sm:grid-cols-3" : "sm:grid-cols-4"}`} data-testid={`pricing-tier-${index}`}>
      {cells.map(([key, label, testId, value, placeholder, unit]) => (
        <div key={key}>
          <UnitLabel text={t(label)} unit={unitOf(unit, currency, t)} />
          <NeuInput type="number" disabled={readonly}
                    step={key === "price_per_employee" ? "0.01" : undefined}
                    data-testid={testId} placeholder={placeholder} value={value}
                    className={readonly ? "cursor-not-allowed opacity-70" : ""}
                    onChange={readonly ? undefined : (e) => onChange(index, key, e.target.value)} />
        </div>
      ))}
      {!readonly && (
        <div className="flex items-end">
          <NeuButton variant="danger" className="px-3 py-2" data-testid={`tier-remove-${index}`} onClick={onRemove}>
            <Trash2 className="h-4 w-4" />
          </NeuButton>
        </div>
      )}
    </li>
  );
};
